import { render, staticRenderFns } from "./HistoryOnSite.vue?vue&type=template&id=35a13ee0&scoped=true&"
import script from "./HistoryOnSite.vue?vue&type=script&lang=js&"
export * from "./HistoryOnSite.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOnSite.vue?vue&type=style&index=0&id=35a13ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a13ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VTextField})
